import {
	type BondRequestBondType,
	CommercialSuretyBondType,
	ContractCategoryBondType,
	ContractSuretyType,
} from "@inrev/common";

export const LEGACY_BOND_TYPE_OPTIONS: { label: string; value: BondRequestBondType }[] = [
	{ label: "Bid Bond", value: ContractSuretyType.bid },
	{ label: "Final Bond", value: ContractSuretyType.final },
];

export const LEGACY_ADMIN_BOND_TYPE_OPTIONS: { label: string; value: BondRequestBondType }[] = [
	...LEGACY_BOND_TYPE_OPTIONS,
	{ label: "Bid to Final Bond", value: ContractSuretyType.bid_to_final },
];

export const buildCommercialBondTypeOptions = (includeCommercial: boolean) => [
	...ContractCategoryBondType.options(),
	...(includeCommercial ? CommercialSuretyBondType.options() : []),
];
